// extracted by mini-css-extract-plugin
module.exports = {"card-not-found-block":"LandRegistrationGuide_card-not-found-block__Ke2Oe"};